import { render, staticRenderFns } from "./ScheduleSummary.vue?vue&type=template&id=4b518cd9"
import script from "./ScheduleSummary.vue?vue&type=script&lang=js"
export * from "./ScheduleSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports